/**
 * created by xcc
 * 音频编辑组件
 */
import React, {Component} from 'react';
class AudioEdit extends Component {

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const {audioUrl, audioName, audioEditCallback} = this.props;
        return (
            <>
                <a type={'link'}
                   style={{border: 'none', marginLeft: 32, color: "#0050B3", fontSize: 14}}
                   onClick={() => {
                       let that = this;
                       window.audioediter.editSuccessCallBack = function (obj) {
                           audioEditCallback(obj)
                       };
                       window.audioediter.open(audioUrl, audioName);
                   }}
                >音频编辑</a>
            </>
        )
    }
}

AudioEdit.propTypes = {};

export default AudioEdit;
